import { TApplicationState } from '../../types/redux';

export function getDisclaimerText(state: TApplicationState) {
  return state.newbuilding.disclaimerText;
}
